// src/components/Templates/Footer/FooterAddress/FooterAddress.component.tsx
import React from "react";
import S from "./FooterAddress.module.scss";

interface FooterAddressProps {
    title: string;
    text?: {
        markup: string;
    };
}

const FooterAddress: React.FC<FooterAddressProps> = ({ title, text }) => (
    <div className={S.addressWrapper}>
        <h4>{title}</h4>
        {text?.markup && <div dangerouslySetInnerHTML={{ __html: text.markup }} />}
    </div>
);

export default FooterAddress;
